import React, { Fragment, useContext, useState } from "react";
import companyLogo from "../assets/logo.png";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { Flip, toast } from "react-toastify";
import { AppContext } from "../context/AppContext";
import { PulseLoader } from "react-spinners";
import { jwtDecode } from "jwt-decode";

function Login() {
  const navigate = useNavigate();
  const { authLoading, userLogin } = useContext(AppContext);
  const [isText, setIsText] = useState(false);
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (credentials.username.length == 0 || credentials.password.length == 0) {
      setIsError(true);
      return;
    }

    const payload = {
      ...credentials,
      deviceId: "",
      type: "",
      model: "",
      APKName: "",
      APKVersion: "",
      OsVersion: "",
      token: "",
      acceptedPermissions: "",
      tokenUpdate: "No",
    };

    await userLogin(payload, {
      onSuccess: (res) => {
        const name = res.name ?? "User";

        window.localStorage.setItem("UserRetention", res?.token);
        window.sessionStorage.setItem("shopId", res?.id);
        window.localStorage.setItem("siteURL", res?.pluginDomain);
        window.sessionStorage.setItem("shopName", res?.shopName);
        window.localStorage.setItem("shopCustomToken", res?.shopCustomToken);

        toast.success(`Welcome ${name}`);

        const tokenValue = jwtDecode(res?.token);

        //! to handle token exp
        setTimeout(() => {
          window.location.href = "/";
        }, 1000);
      },
      onFailed: (err) => {
        console.log("error", err);
        toast.error("Incorrect Credentials!");
      },
    });
  };

  return (
    <Fragment>
      <div className="login_wrapper">
        <div className="login_component">
          <div className="logo__">
            <img src={companyLogo} alt="" />
          </div>
          <h4 className="mb-12 mt-12 fs-4">Sign In to your Account</h4>
          <p className="mb-10 text-secondary-light text-lg">
            Welcome back! please enter your detail
          </p>
          <br />
          <form action="" onSubmit={handleSubmit}>
            <div className="icon-field mb-16 position-relative">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                name="username"
                className="form-control h-56-px bg-neutral-50 radius-12"
                id={
                  isError && credentials.username.length == 0 ? "err_form" : ""
                }
                placeholder="Email"
                value={credentials.username}
                onChange={handleChange}
              />
            </div>
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  name="password"
                  type={!isText ? "password" : "text"}
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  id={
                    isError && credentials.password.length == 0
                      ? "err_form"
                      : ""
                  }
                  placeholder="Password"
                  value={credentials.password}
                  onChange={handleChange}
                />
              </div>
              <span
                className={
                  isText
                    ? "toggle-password  cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light ri-eye-off-line"
                    : "toggle-password  cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light ri-eye-line"
                }
                data-toggle="#your-password"
                onClick={() => setIsText(!isText)}
              />
            </div>
            <br />
            <button
              type="submit"
              className="dash_btn"
              disabled={authLoading}
            >
              {!authLoading ? "Login" : <PulseLoader color="#fff" size={10} />}
            </button>
          </form>
        </div>
      </div>
    </Fragment>
  );
}

export default Login;
